/* IDA : upsells panier */
(function(){
  function sid(){var d=document.querySelector('cart-drawer');return d&&d.dataset.sectionId}
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-ida-up-add]');if(!b)return;
    e.preventDefault();if(b.disabled)return;b.disabled=true;var old=b.textContent;b.textContent='…';
    var s=sid();
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[(function(){var it={id:parseInt(b.getAttribute('data-ida-up-add'),10),quantity:1};var g=b.getAttribute('data-ida-up-gifts');if(g&&g!=='[]')it.properties={_ida_gifts:g};return it})()],sections:s||''})})
    .then(function(r){return r.json()}).then(function(resp){
      if(resp.status&&resp.status>=400){throw new Error(resp.description||'err')}
      var icon=document.querySelector('cart-icon');var cur=icon&&icon.getCurrentItemCount?icon.getCurrentItemCount():null;
      if(s&&resp.sections){document.dispatchEvent(new CustomEvent('cart:updated',{detail:{resource:{},data:{itemCount:(cur||0)+1,source:'ida-upsell',sections:resp.sections}}}));document.dispatchEvent(new CustomEvent('cart:open'))}
      else{location.reload()}
    }).catch(function(){b.disabled=false;b.textContent=old});
  });
})();